var map = {
	"./AcademyCatalog.vue": [
		70710,
		710
	],
	"./AppLayout.vue": [
		90313
	],
	"./Blank.vue": [
		49341,
		9341
	],
	"./BlankAcademy.vue": [
		25442,
		5442
	],
	"./Flow.vue": [
		27878,
		7878
	],
	"./FullHeight.vue": [
		10661,
		661
	],
	"./Login.vue": [
		63232,
		3232
	],
	"./Main.vue": [
		25463,
		5463
	],
	"./MainBg.vue": [
		19766,
		9766
	],
	"./NoHeader.vue": [
		14305,
		4305
	],
	"./v2/Main.vue": [
		1976,
		1976
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 20062;
module.exports = webpackAsyncContext;